import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Table, Button, Input } from 'reactstrap';
import { useAlert } from 'hooks';
import { useUser } from 'context/UserContext';
import AlertModal from 'components/AlertModal';
import { getErrorMessage } from 'helpers/errors';
import { getCuotasPendientes, Debt } from 'features/matriculates/matriculatesAPI';
import { fCurrency } from 'helpers/formatNumber';
import { getCuotasPreferenceId } from 'features/mercadopago/mercadopagoAPI';

export default function CuotasPendientes() {
  const [showAlert, message, alert] = useAlert(false, '');
  const [debts, setDebts] = useState<Debt[]>([]);
  // Convenio y matrícula se seleccionan como bloques independientes, cada uno en orden
  const [selectedConvenio, setSelectedConvenio] = useState(0);
  const [selectedMatricula, setSelectedMatricula] = useState(0);
  const [hidePayButton, setHidePayButton] = useState(false);

  const { getMatricula } = useUser();
  const matriculateId = getMatricula();
  if (!matriculateId) {
    return null;
  }

  const selectedCount = selectedConvenio + selectedMatricula;

  const blockPositions = debts.map((debt, index) =>
    debts.slice(0, index).filter(d => d.convenio === debt.convenio).length,
  );

  const isSelected = (index: number) => {
    const blockSelected = debts[index].convenio ? selectedConvenio : selectedMatricula;
    return blockPositions[index] < blockSelected;
  };

  const handleCheckboxChange = (index: number) => {
    const position = blockPositions[index];
    const setBlockSelected = debts[index].convenio ? setSelectedConvenio : setSelectedMatricula;
    setBlockSelected(isSelected(index) ? position : position + 1);
  };

  const getSelectedDebts = (): Debt[] => {
    return debts
      .filter((_, index) => isSelected(index))
      .filter(debt => debt.formaPago === 'Efectivo');
  };

  const handlePagar = async () => {
    const cuotasSeleccionadas = getSelectedDebts();
    const preferenceId = await getCuotasPreferenceId(+matriculateId, cuotasSeleccionadas);

    if (!preferenceId) {
      alert(true, 'No se pudo conectar con MercadoPago para iniciar el pago. Por favor, intente nuevamente más tarde');
      return;
    }

    const checkoutUrl = `https://www.mercadopago.com.ar/checkout/v1/redirect?preference_id=${preferenceId}`;
    window.open(checkoutUrl, '_blank');
    alert(true, 'Una vez realizado el pago, puede tardar hasta un día en verse reflejado en el sistema.');
  };

  useEffect(() => {
    getCuotasPendientes(parseInt(matriculateId))
      .then(data => {
        setDebts(data);

        setHidePayButton(data.some(debt => debt.formaPago !== 'Efectivo'));
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudieron obtener las cuotas pendientes');
      });
  }, []);

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>Cuotas Pendientes</Col>
                <Col md={4} className="text-right">
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th style={{ width: '50px' }}></th>
                    <th>Concepto</th>
                    <th style={{ textAlign: 'right' }}>Monto</th>
                    <th style={{ textAlign: 'right' }}>Recargo</th>
                    <th style={{ textAlign: 'right' }}>Total</th>
                    <th>Forma de Pago</th>
                    <th>Convenio</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    debts.map((row, index) => (
                      <tr key={ `row_${row.opcion}_${index}` }>
                        <td style={{ textAlign: 'center' }}>
                          { !hidePayButton
                            ?
                              <Input
                                type="checkbox"
                                checked={isSelected(index)}
                                onChange={() => handleCheckboxChange(index)}
                                style={{ margin: 0, position: 'relative' }}
                              />
                            : null
                          }
                        </td>
                        <td>{ row.concepto }</td>
                        <td style={{ textAlign: 'right' }}>{ fCurrency(row.monto) }</td>
                        <td style={{ textAlign: 'right' }}>{ fCurrency(row.recargo) }</td>
                        <td style={{ textAlign: 'right' }}>{ fCurrency(+row.monto+row.recargo) }</td>
                        <td>{ row.formaPago }</td>
                        <td>{ row.convenio ? 'Si' : 'No' }</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
              { !hidePayButton
                ?
                  <div className="text-right mt-3">
                    <Button
                      color="primary"
                      disabled={selectedCount === 0}
                      onClick={handlePagar}
                    >
                      Pagar ({selectedCount} {selectedCount === 1 ? 'cuota' : 'cuotas'})
                    </Button>
                  </div>
                : null
              }
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
